import {
  Component,
  OnInit,
  AfterViewInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input,
  SimpleChanges,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-simple-card",
  templateUrl: "./booth-card.component.html",
  styleUrls: ["./booth-card.component.scss"],
  animations: fuseAnimations,
})
export class BoothCardComponent implements OnInit, AfterViewInit {
  @ViewChild("extra_container", { read: ElementRef })
  extra_container: ElementRef;

  private isViewInit = false;

  public booth: string = "";
  public area: string = "";
  public booth_no: string = "";
  public hideIt = false;
  public showPlaceHolder = false;
  public card_color = "";

  public callback = function () {
    //Card Click Callback
  };

  public afterViewInit = () => {};

  constructor(private cdr: ChangeDetectorRef, private helper: HelperService) {
    this.card_color = helper.getRandomColor(6);
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.afterViewInit();
    this.isViewInit = true;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCardClick(): void {
    this.callback();
  }

  setAsPlaceHolder(): void {
    this.hideIt = true;
    this.showPlaceHolder = true;
  }

  addExtraContainerElements(html: string): void {
    this.extra_container.nativeElement.innerHTML = html;
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  hideExtraContainer() {
    if (!this.isViewInit) return false;
    else
      return (
        !this.extra_container ||
        this.extra_container.nativeElement.innerHTML == ""
      );
  }

  getExtraContainerHtml(): string {
    if (this.extra_container)
      return this.extra_container.nativeElement.innerHTML;
    return "";
  }
}
